import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ScaleLoader } from "react-spinners";
import stripePay from "../../assets/images/payment/stripe.jpg";

const CheckoutForm = ({ order, user }) => {
  const [cardError, setCardError] = useState("");
  const [success, setSuccess] = useState("");
  const [processing, setProcessing] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [clientSecret, setClientSecret] = useState("");

  const stripe = useStripe();
  const elements = useElements();
  const { _id, price } = order;

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("https://food-for-you-server.vercel.app/create-payment-intent", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ price }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [price]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const card = elements.getElement(CardElement);
    if (card === null) {
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card,
    });

    if (error) {
      console.log(error);
      // setCardError(error.message);
      toast.error(error.message);
      setProcessing(false);
    } else {
      setCardError("");
    }
    setSuccess("");

    setProcessing(true);
    const { paymentIntent, error: confirmError } =
      await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: card,
          billing_details: {
            name: user?.displayName,
            email: user?.email,
          },
        },
      });

    if (confirmError) {
      // setCardError(confirmError.message);
      // toast.error(confirmError.message)
      setProcessing(false);
      return;
    }
    console.log("paymentIntent:", paymentIntent);

    if (paymentIntent.status === "succeeded") {
      console.log("card info", card);

      // store payment info in the database
      const payment = {
        price,
        transactionId: paymentIntent.id,
        orderId: _id,
        name: user?.displayName,
        email: user?.email,
      };
      fetch("https://food-for-you-server.vercel.app/payments", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(payment),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);

          if (data.insertedId) {
            setSuccess("Congratulations! your payment is completed");
            setTransactionId(paymentIntent.id);
          }
        });
    }
    setProcessing(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="">
        <div className="shadow-sm card-log rounded-3 py-3 ps-3">
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
          />
        </div>

        <div className="borde shadow-sm p-2 rounded-3 text-center m-pay">
          <p className="text-secondary text-center mb-0">
            <span className="fw-semibold text-secondary"> Email Address:</span>{" "}
            {user?.email}
          </p>
        </div>

        <div className="d-flex justify-content-between align-items-center m-pay">
          <div className="">
            <button
              className="btn btn-sm text-white border-none btn-info bg-opacity- bg-gradient px-3 py-1 rounded-2"
              type="submit"
              disabled={!stripe || !clientSecret}
            >
              {processing ? (
                <div className="d-flex justify-content-center align-items-center py-1">
                  <ScaleLoader color="#fff" height="13" speedMultiplier=".6" />
                </div>
              ) : (
                <div className="fw-bold">
                  Pay
                  <span className="fw-bold mb-0">
                    <span className="fw-bold ms-1">$</span>
                  </span>
                  {price}
                </div>
              )}
            </button>
          </div>

          <div className="font-semibol">
            <LazyLoadImage
              src={stripePay}
              alt="Stripe"
              className="stripe-form img-fluid"
              placeholderSrc={stripePay}
              effect="blur"
            />
          </div>
        </div>
      </form>
      <p className="text-danger">{cardError}</p>

      <div className="">
        {success && (
          <div className="mt-pay text-center rounded-3">
            <p className="fw-bold mb-1 pay-success">{success} </p>
            <p>
              <span className="fw-semibold text-black">
                Your transactionId is:
              </span>
              <span className="fw-bold mx-1 orange">
                {" "}
                <br />
                {transactionId}
              </span>{" "}
              <br />
              <span className="fw-semibold">
                The delivery will come in just 30 minutes!
              </span>
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default CheckoutForm;
